<!-- eslint-disable @angular-eslint/template/no-negated-async -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->

<ng-container
  *ngIf="{
    cards: cards$ | async,
    cart: cart$ | async,
  } as content"
>
  <ng-container *ngIf="!(isUpdating$ | async); else loading">
    <div role="status" [attr.aria-label]="'common.loaded' | cxTranslate"></div>
    <ng-container *ngIf="content.cards?.length && !addressFormOpened; then showExistingAddresses; else newAddressForm"> </ng-container>

    <ng-template #showExistingAddresses>
      <h2 class="cx-checkout-title">
        {{ 'checkoutAddress.modalTitle' | cxTranslate }}
      </h2>

      <p class="cx-checkout-text">
        {{ 'checkoutAddress.selectYourDeliveryAddress' | cxTranslate }}
      </p>

      @if (content.cards) {
        <table-addresses
          [addressCards]="content.cards"
          [currentCard]="{ address: content.cart?.deliveryAddress!, card: {} }"
          (_onShowNewAddressForm)="showNewAddressForm()"
          (_onSelectAddress)="customSelectAddress($event)"
        ></table-addresses>
      }

      <div class="actions">
        <button class="btn btn-primary btn-close w-100" (click)="close()">Close</button>
      </div>
    </ng-template>

    <ng-template #newAddressForm>
      <h2 class="cx-checkout-title">
        {{ 'checkoutAddress.newDropShip' | cxTranslate }}
      </h2>
      <cx-address-form
        *ngIf="content.cards?.length; else initialAddressForm"
        [showTitleCode]="true"
        (backToAddress)="hideNewAddressForm(false)"
        (submitAddress)="addAddress($event)"
        [addressType]="ADDRESS_TYPE.DROP_SHIP_ADDRESS"
      ></cx-address-form>

      <ng-template #initialAddressForm>
        <cx-address-form
          [showTitleCode]="true"
          [setAsDefaultField]="!isGuestCheckout"
          [addressData]="selectedAddress!"
          cancelBtnLabel="{{ backBtnText | cxTranslate }}"
          (backToAddress)="hideNewAddressForm(true)"
          (submitAddress)="addAddress($event)"
        ></cx-address-form>
      </ng-template>
    </ng-template>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
